import { useNavigate } from 'react-router-dom';
import { MinusIconGe, PlusIconGe, TransferOperationIcon } from 'src/assets';
import { useTranslation } from 'src/hooks';
import { OperationItem } from './OperationItem';
import { RowWrapper } from './styles';

const operations = [
  {
    id: 1,
    title: 'dashboard_buy',
    icon: <PlusIconGe />,
    route: '/buy',
  },
  {
    id: 2,
    title: 'dashboard_sell',
    icon: <MinusIconGe />,
    route: '/sell',
  },
  {
    id: 3,
    title: 'inside_transaction',
    disabled: true,
    comingSoon: true,
    icon: <TransferOperationIcon />,
  },
];

type OperationType = {
  id: number;
  title: string;
  icon: JSX.Element;
  route?: string;
  comingSoon?: boolean;
  disabled?: boolean;
};
type OperationsSecondRowProps = {
  handleOperation?: () => void;
};
export const OperationsSecondRow: React.FC<OperationsSecondRowProps> = ({
  handleOperation,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <RowWrapper>
      {operations.map((op: OperationType) => {
        const handleOperationClick = () => {
          if (op.route) {
            navigate(op.route);
            handleOperation?.();
          }
        };

        return (
          <OperationItem
            key={op.id}
            title={t(op.title)}
            icon={op.icon}
            disabled={op.disabled}
            comingSoon={op.comingSoon}
            handleClick={handleOperationClick}
          />
        );
      })}
    </RowWrapper>
  );
};
